// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 22023, offsets 557653:557706. Structure and names inferred from code, not screenshots.

const testDocuments = [];
const recoveredExportvg = [];
export { testDocuments, recoveredExportvg as vg };
